const contactDetail = {
	header: 'Detail kontaktu',
	owner: 'Vlastník',
	client: 'Klient',
	insuranceContract: 'Pojistná smlouva',
};

const feedback = {
	feedbackTitle: 'Zpětná vazba',
	feedBackConfirmHeader: 'Opravdu chcete uložit zpětnou vazbu',
	partnerLocked: 'U kontaktu nelze vykázat zpětnou vazbu. Klient nebyl v průběhu kampaně odemčen.',
	partnerNotFoundInCCD: 'Klient nebyl nalezen v CCD.',
};

const additionalData = {
	additionalDataSubheader: 'Doplňující data',
	birthNumber: 'Rodné číslo',
};

const authorizedPersons = {
	authorizedPersons: 'Oprávněné osoby',
};

const contactNotes = {
	contactNotesSubheader: 'Poznámky ke kontaktu',
};

const contactHistory = {
	contactHistorySubheader: 'Historie kontaktu',
	dateTIme: 'Datum a čas',
	chengeMade: 'Změnu provedl',
	originalValue: 'Původní hodnota',
	newValue: 'Nová hodnota',
	solver: 'Řešitel',
};

const contactDetailSidebar = {
	contactSource: 'Zdroj kontaktu',
	letterSend: 'Odeslání dopisu',
	psEndDate: 'Datum konce smlouvy',
	degree: 'Tituly',
	surname: 'Příjmení',
	name: 'Jméno',
	businessIn: 'IČO',
	businessName: 'Název firmy',
	dateNumber: 'Rodné číslo',
	street: 'Ulice',
	town: 'Město / obec',
	zipCode: 'PSČ',
	phoneNumber: 'Telefon 1',
	phoneNumberTwo: 'Telefon 2',
	email: 'Email',
	policyNo: 'Číslo PS',
	proposalNo: 'Číslo návrhu PS',
	product: 'Produkt',
	amount: 'Částka',
	bruttoProduction: 'Spárovaná produkce',
};

export default {
	...contactDetail,
	...feedback,
	...additionalData,
	...authorizedPersons,
	...contactNotes,
	...contactHistory,
	...contactDetailSidebar,
};
